import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { BaseSearchFormComponent } from '@app/shared/components/base-search-form/base-search-form.component';
import { enumManagementSearchKey, SearchHelper } from '@helpers/search-helper';
import { ManagementVoyageSearchModel } from '@data-layer/models/management';
import { IDefaultSelect } from '@interfaces/default-select';
import { Observable, ReplaySubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTimezoneService } from '@services/date-timezone.service';
import { enumVoyageStatus, enumVoyageType } from '@data-layer/enums/lcl';
import { TranslateService } from '@ngx-translate/core';
import { ManagementAgentSearchModel } from '@data-layer/models/management/agents';
import { LclPortModel } from '@data-layer/models/lcl';

@Component({
  selector: 'voyage-search-form',
  templateUrl: './voyage-search-form.component.html',
  styleUrls: ['./voyage-search-form.component.scss'],
})
export class VoyageSearchFormComponent extends BaseSearchFormComponent<ManagementVoyageSearchModel> implements OnDestroy {
  @Input() public searchAgents: Observable<ManagementAgentSearchModel[]>;
  @Input() public searchPorts: Observable<LclPortModel[]>;

  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;
  public statusItems: IDefaultSelect[] = [];
  public voyageTypesItems: IDefaultSelect[] = [];

  protected key: enumManagementSearchKey = enumManagementSearchKey.VOYAGE;
  protected fieldsForSettingStartOfDay: string[] = ['departureDateFrom'];
  protected fieldsForSettingEndOfDay: string[] = ['departureDateTo'];

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected dateTimezoneService: DateTimezoneService,
    protected searchHelper: SearchHelper,
    private translateService: TranslateService,
  ) {
    super();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  protected initForm(): void {
    this.formGroup = new UntypedFormGroup({
      voyageReferenceNumber: new UntypedFormControl(),
      voyageNumber: new UntypedFormControl(),
      departureDateFrom: new UntypedFormControl(),
      departureDateTo: new UntypedFormControl(),
      statuses: new UntypedFormControl(null),
      fromPort: new UntypedFormControl(),
      toPort: new UntypedFormControl(),
      originAgentId: new UntypedFormControl(null),
      destinationAgentId: new UntypedFormControl(null),
      freightAgentId: new UntypedFormControl(null),
      voyageType: new UntypedFormControl(null),
    });

    this.statusItems = Object.keys(enumVoyageStatus)
      .filter((item: string) => Number(item) > -1)
      .map((item: any) => ({
        id: Number(item),
        label: this.translateService.instant('VOYAGE_STATUS.' + enumVoyageStatus[item]),
        value: Number(item),
      }));

    this.voyageTypesItems = Object.keys(enumVoyageType)
      .filter((item: string) => Number(item) > -1)
      .map((item: any) => ({
        id: Number(item),
        label: this.translateService.instant('LABELS.' + enumVoyageType[item]),
        value: Number(item),
      }));

    const querySearch: any = this.querySearch;
    const hasQuerySearch: boolean = Object.keys(querySearch).length > 0;
    const lastSearch: any = SearchHelper.getLastSearch(this.key);
    const search: any = hasQuerySearch ? querySearch : lastSearch;

    if (search) {
      this.formGroup.patchValue(search);
      this.updateFields();
      if (!hasQuerySearch && lastSearch) {
        this.setQueryParams();
      }
    }

    this.search.emit(this.formGroup.value);
  }
}
